import React from "react";
import { Chip, ChipProps } from "@mui/material";
import ScheduleIcon from "@mui/icons-material/Schedule";

interface TopicalityChipProps {
  /** 賞味期限の有無。undefined は未判定 */
  isTopical: boolean | undefined;
  /**
   * 普遍（false）と未判定（undefined）も表示するか。
   * 一覧では時事だけを目立たせたいので省き、詳細では全状態を出す。
   */
  showAllStates?: boolean;
  size?: ChipProps["size"];
}

/**
 * お題の賞味期限（isTopical）を示すChip。
 */
const TopicalityChip: React.FC<TopicalityChipProps> = ({
  isTopical,
  showAllStates = false,
  size = "small",
}) => {
  if (isTopical === true) {
    return (
      <Chip icon={<ScheduleIcon />} label="時事" size={size} color="warning" variant="outlined" />
    );
  }
  if (!showAllStates) return null;
  if (isTopical === false) {
    return <Chip label="普遍" size={size} variant="outlined" />;
  }
  return <Chip label="賞味期限 未判定" size={size} variant="outlined" />;
};

export default TopicalityChip;
